"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveTotalXylenes = exports.derivePyrethrinResult = exports.deriveSpinosadResult = exports.deriveTotalAflatoxinsResult = exports.areAnySubAnalytesAboveLOD = exports.areAnySubAnalytesAboveLOQ = exports.MYCOTOXINS_LIST = exports.PassFailColumn = exports.ActionLimitsColumnFactory = exports.ResultsPercentageColumnFactory = exports.DefaultResultsColumnFactory = exports.LOQColumnFactory = exports.LODColumnFactory = exports.AnalyteColumn = exports.determineRowPassFail = void 0;
var math = __importStar(require("mathjs"));
var utils_1 = require("../../utils");
var calculations_1 = require("../../utils/calculations");
var lodash_1 = require("lodash");
var R = __importStar(require("ramda"));
var determineRowPassFail = function (analyteProp) {
    if (analyteProp === void 0) { analyteProp = "name"; }
    return function (row) {
        var _a, _b;
        var analyteValue = utils_1.findAnalyteResults({
            analyteProp: analyteProp,
            rawName: row.parameter.referenceComponent.rawName,
        })(row.results.components);
        if (typeof (analyteValue === null || analyteValue === void 0 ? void 0 : analyteValue.final_amount) !== "number")
            return "Pass";
        if (lodash_1.isNil((_a = row.stateRegulation) === null || _a === void 0 ? void 0 : _a.actionLimit))
            return "N/A";
        if (analyteValue.final_amount <= (row.parameter.levelOfDetection || 0)) {
            return "Pass";
        }
        if (row.stateRegulation.actionLimit >=
            calculations_1.correctForDensity((_b = analyteValue === null || analyteValue === void 0 ? void 0 : analyteValue.final_amount) !== null && _b !== void 0 ? _b : 0, row.density)) {
            return "Pass";
        }
        return "Fail";
    };
};
exports.determineRowPassFail = determineRowPassFail;
exports.AnalyteColumn = {
    accessor: "parameter.referenceComponent.displayName",
    Header: "Analyte",
    width: 50,
};
var LODColumnFactory = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.solidDisplayUnits, solidDisplayUnits = _c === void 0 ? "ug/g" : _c, _d = _b.volumeDisplayUnits, volumeDisplayUnits = _d === void 0 ? "ug/mL" : _d, _e = _b.precision, precision = _e === void 0 ? 6 : _e;
    return ({
        accessor: function (row) {
            try {
                return typeof row.parameter.levelOfDetection === "number"
                    ? utils_1.convertToDisplayUnits(math
                        .unit(row.parameter.levelOfDetection, utils_1.convertFromDisplayUnits(row.isSolid
                        ? row.parameter.weightUnitOfMeasure || "ug/g"
                        : row.parameter.volumeUnitOfMeasure || "ug/mL"))
                        .to(row.isSolid ? solidDisplayUnits : volumeDisplayUnits)
                        .format({ notation: "fixed", precision: precision })
                        .toString()
                        .replace(" / ", "/"))
                    : "N/A";
            }
            catch (err) {
                console.error("Error rendering in default lod column", row, err);
                return "Error";
            }
        },
        Header: "LOD",
        width: 50,
    });
};
exports.LODColumnFactory = LODColumnFactory;
var LOQColumnFactory = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.solidDisplayUnits, solidDisplayUnits = _c === void 0 ? "ug/g" : _c, _d = _b.volumeDisplayUnits, volumeDisplayUnits = _d === void 0 ? "ug/mL" : _d, _e = _b.precision, precision = _e === void 0 ? 6 : _e;
    return ({
        accessor: function (row) {
            try {
                return typeof row.parameter.levelOfQuantitation === "number"
                    ? utils_1.convertToDisplayUnits(math
                        .unit(row.parameter.levelOfQuantitation, utils_1.convertFromDisplayUnits(row.isSolid
                        ? row.parameter.weightUnitOfMeasure || "ug/g"
                        : row.parameter.volumeUnitOfMeasure || "ug/mL"))
                        .to(row.isSolid ? solidDisplayUnits : volumeDisplayUnits)
                        .format({ notation: "fixed", precision: precision })
                        .toString()
                        .replace(" / ", "/"))
                    : "N/A";
            }
            catch (err) {
                console.error("Error rendering in default loq column", row, err);
                return "Error";
            }
        },
        Header: "LOQ",
        width: 50,
    });
};
exports.LOQColumnFactory = LOQColumnFactory;
var DefaultResultsColumnFactory = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.solidDisplayUnits, solidDisplayUnits = _c === void 0 ? "ug/g" : _c, _d = _b.volumeDisplayUnits, volumeDisplayUnits = _d === void 0 ? "ug/mL" : _d, _e = _b.precision, precision = _e === void 0 ? 3 : _e, _f = _b.analyteProp, analyteProp = _f === void 0 ? "name" : _f;
    return ({
        accessor: function (row) {
            var _a;
            var result = utils_1.findAnalyteResults({
                rawName: row.parameter.referenceComponent.rawName,
                analyteProp: analyteProp,
            })(row.results.components);
            try {
                if (typeof (result === null || result === void 0 ? void 0 : result.final_amount) === "string")
                    return result.final_amount;
                if (typeof (result === null || result === void 0 ? void 0 : result.final_amount) !== "number")
                    return "ND";
                if (result.final_amount <= (row.parameter.levelOfDetection || 0))
                    return "ND";
                if (result.final_amount <= (row.parameter.levelOfQuantitation || 0))
                    return "<LOQ";
                return utils_1.convertToDisplayUnits(math
                    .unit(calculations_1.correctForDensity((_a = result === null || result === void 0 ? void 0 : result.final_amount) !== null && _a !== void 0 ? _a : 0, row.density), utils_1.convertFromDisplayUnits(row.isSolid
                    ? lodash_1.get(row, "parameter.weightUnitOfMeasure", "ug/g")
                    : lodash_1.get(row, "parameter.volumeUnitOfMeasure", "ug/mL")))
                    .to(row.isSolid ? solidDisplayUnits : volumeDisplayUnits)
                    .format({ notation: "fixed", precision: precision })
                    .toString()
                    .replace(" / ", "/"));
            }
            catch (err) {
                console.error("Error rendering in default results column", row, err);
                return "Error";
            }
        },
        Header: "Results",
        width: 50,
    });
};
exports.DefaultResultsColumnFactory = DefaultResultsColumnFactory;
var ResultsPercentageColumnFactory = function (_a) {
    var _b = _a.precision, precision = _b === void 0 ? 4 : _b;
    return ({
        accessor: function (row) {
            var _a;
            var result = utils_1.findAnalyteResults({
                rawName: row.parameter.referenceComponent.rawName,
            })(row.results.components);
            return typeof (result === null || result === void 0 ? void 0 : result.final_amount) === "number" &&
                (result === null || result === void 0 ? void 0 : result.final_amount) > (row.parameter.levelOfQuantitation || 0)
                ? calculations_1.convertPpmToPercent(calculations_1.correctForDensity((_a = result.final_amount) !== null && _a !== void 0 ? _a : 0, row.density))
                    .toFixed(precision)
                    .toString() + "%"
                : "N/A";
        },
        Header: "Results (%)",
        width: 50,
    });
};
exports.ResultsPercentageColumnFactory = ResultsPercentageColumnFactory;
var ActionLimitsColumnFactory = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.solidDisplayUnits, solidDisplayUnits = _c === void 0 ? "ug/g" : _c, _d = _b.volumeDisplayUnits, volumeDisplayUnits = _d === void 0 ? "ug/mL" : _d, _e = _b.precision, precision = _e === void 0 ? 3 : _e;
    return ({
        accessor: function (row) {
            var _a;
            try {
                return typeof ((_a = row.stateRegulation) === null || _a === void 0 ? void 0 : _a.actionLimit) === "number"
                    ? utils_1.convertToDisplayUnits(math
                        .unit(row.stateRegulation.actionLimit, utils_1.convertFromDisplayUnits(row.isSolid
                        ? row.stateRegulation.weightUnitOfMeasure || "ug/g"
                        : row.stateRegulation.volumeUnitOfMeasure || "ug/mL"))
                        .to(row.isSolid ? solidDisplayUnits : volumeDisplayUnits)
                        .format({ notation: "fixed", precision: precision })
                        .toString()
                        .replace(" / ", "/"))
                    : "N/A";
            }
            catch (err) {
                console.error("Error rendering in default action limits column", row, err);
                return "Error";
            }
        },
        Header: "Action Limits",
        width: 50,
    });
};
exports.ActionLimitsColumnFactory = ActionLimitsColumnFactory;
exports.PassFailColumn = {
    accessor: exports.determineRowPassFail(),
    Header: "Pass/Fail",
    width: 50,
};
exports.MYCOTOXINS_LIST = [
    "mycotoxin b1",
    "mycotoxin b2",
    "mycotoxin g1",
    "mycotoxin g2",
    "ochratoxin a",
    "Total Aflatoxins",
];
var sumComponentResults = function (_a) {
    var _b = _a.analyteKey, analyteKey = _b === void 0 ? "analyte" : _b, analyteName = _a.analyteName, subAnalytes = _a.subAnalytes;
    return function (_a) {
        var _b;
        var components = _a.components, parameters = _a.parameters;
        return _b = {},
            _b[analyteKey] = analyteName,
            _b.final_amount = components.reduce(function (acc, component) {
                var _a;
                if (subAnalytes.includes(component[analyteKey])) {
                    var loq = (_a = parameters.find(function (_a) {
                        var rawName = _a.referenceComponent.rawName;
                        return component[analyteKey] === rawName;
                    })) === null || _a === void 0 ? void 0 : _a.levelOfQuantitation;
                    return !!loq && (component.final_amount || 0) >= loq
                        ? acc + (component.final_amount || 0)
                        : acc;
                }
                return acc;
            }, 0),
            _b;
    };
};
var checkLevels = function (comparitor) {
    return function (_a) {
        var _b = _a.analyteKey, analyteKey = _b === void 0 ? "analyte" : _b, subAnalytes = _a.subAnalytes;
        return function (_a) {
            var components = _a.components, parameters = _a.parameters;
            return R.any(function (component) {
                var _a;
                if (subAnalytes.includes(component[analyteKey])) {
                    var _b = (_a = parameters.find(function (_a) {
                        var rawName = _a.referenceComponent.rawName;
                        return component[analyteKey] === rawName;
                    })) !== null && _a !== void 0 ? _a : {}, levelOfQuantitation = _b.levelOfQuantitation, levelOfDetection = _b.levelOfDetection;
                    return comparitor((component === null || component === void 0 ? void 0 : component.final_amount) || 0, levelOfDetection, levelOfQuantitation);
                }
                return false;
            }, components);
        };
    };
};
exports.areAnySubAnalytesAboveLOQ = checkLevels(function (finalAmount, _, levelOfQuatitaion) {
    return !!levelOfQuatitaion && finalAmount > levelOfQuatitaion;
});
exports.areAnySubAnalytesAboveLOD = checkLevels(function (finalAmount, levelOfDetection) {
    return !!levelOfDetection && finalAmount > levelOfDetection;
});
var deriveSummedAnalyte = function (_a) {
    var _b, _c;
    var _d = _a.analyteKey, analyteKey = _d === void 0 ? "analyte" : _d, analyteName = _a.analyteName, subAnalytes = _a.subAnalytes;
    return R.cond([
        [
            R.compose(R.not, exports.areAnySubAnalytesAboveLOD({ analyteKey: analyteKey, subAnalytes: subAnalytes })),
            R.always((_b = {}, _b[analyteKey] = analyteName, _b.final_amount = "ND", _b)),
        ],
        [
            R.compose(R.not, exports.areAnySubAnalytesAboveLOQ({ analyteKey: analyteKey, subAnalytes: subAnalytes })),
            R.always((_c = {}, _c[analyteKey] = analyteName, _c.final_amount = "<LOQ", _c)),
        ],
        [R.T, sumComponentResults({ analyteName: analyteName, analyteKey: analyteKey, subAnalytes: subAnalytes })],
    ]);
};
exports.deriveTotalAflatoxinsResult = deriveSummedAnalyte({
    analyteName: "Total Aflatoxins",
    subAnalytes: ["mycotoxin b1", "mycotoxin b2", "mycotoxin g1", "mycotoxin g2"],
});
exports.deriveSpinosadResult = deriveSummedAnalyte({
    analyteName: "spinosad",
    subAnalytes: ["spinosyn a", "spinosyn d"],
});
exports.derivePyrethrinResult = deriveSummedAnalyte({
    analyteName: "pyrethrins",
    subAnalytes: ["pyrethrin-i", "pyrethrin-ii"],
});
exports.deriveTotalXylenes = deriveSummedAnalyte({
    analyteKey: "name",
    analyteName: "Total Xylenes",
    subAnalytes: ["m,p- xylenes", "o-xylene"],
});
//# sourceMappingURL=index.js.map